import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import moment  from 'moment';
import { Apollo } from 'apollo-angular';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { DocumentoService } from 'src/app/services/documento.service';
import { UploadDocumentosService } from 'src/app/services/upload-documentos.service';
import { CAUSAS_NOTIFICACION } from './../../../../constants/constants';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-doc-detalle-centro',
  templateUrl: './doc-detalle-centro.component.html',
  styleUrls: ['./doc-detalle-centro.component.scss']
})
export class DocDetalleCentroComponent implements OnInit {
  public documento: any;
  public newComentario: any;
  public causasNotificacion: String[];
  public notificaciones: any = {};
  public path: any;
  datosReemplazo: any = {};
  public date: any
  public otherDate: any
  public fecha: any
  public fileName: any
  public comentarios?: any[] = []
  public datepicker: any
  public tipo: any
  public idPadre: any
  public datepicker2: any
  //UPLOAD
  public files: NgxFileDropEntry[] = [];
  public documentos: any;
  public url: any;
  //comentarios
  public centro: any
  public data: any
  public comentario: any
  public comentarios1: any[] = []
  public comentarios2: any[] = []
  public comentarios3: any[] = []
  public comentarios4: any[] = []
  public comentarios5: any[] = []
  public Documento: any
  public documentoSeleccionado1: any
  public documentoSeleccionado2: any
  public documentoSeleccionado3: any
  public documentoSeleccionado4: any
  public documentoSeleccionado5: any
  public pendiente: any
  public tipoAut: any
  nameDocumento:any
  userLog:any
  public urlDoc: any

  constructor(@Inject(MAT_DIALOG_DATA) public info: {
    id: string,
    refresh: any
  },
    private formBuilder: FormBuilder,
    private apollo: Apollo,
    private documentoServicio: DocumentoService,
    private router: Router,
    private uploadService: UploadDocumentosService, private loginService:LoginService) {
    this.causasNotificacion = CAUSAS_NOTIFICACION
    this.path = this.router.url
    this.buildForm();
    this.date = new Date()
    this.userLog = loginService.getUserData()
  }

  ngOnInit(): void {
    this.getDocumentoById()
    this.buildForm()
    this.dropped(this.files)
  }

  private buildForm(){
    this.notificaciones = this.formBuilder.group({
      causa: ['', [Validators.required]],
      comentario: ['',[Validators.required]],
    });
    this.datosReemplazo = this.formBuilder.group({
      nombre: [''],
      fechaValidez: ['',[Validators.required]],
      fechaCaducidad: ['',[Validators.required]],
      noCaduca: [''],
    });
  }

  dropped(files: any){
    this.uploadService.dropped(files).subscribe((res:any)=>{
      this.nameDocumento = res[0].name;
      this.url = res[0].url
    })
    
   }


  public fileOver(){
    /* console.log(event); */
  }

  public fileLeave(){
    /* console.log(event); */
  }

  getDate(fecha: any){
    this.date = moment(new Date(fecha)).format('Y-MM-DD')
 
  }

  getOtherDate(fecha: any){
    this.otherDate = moment(new Date(fecha)).format('Y-MM-DD')
   
  }

  
  getDocumentoById(){
    console.log(this.info.id)
    this.apollo.watchQuery<any>({
      query: this.documentoServicio.getDocumentoById(),
      variables: {
        "id": this.info.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        console.log(data)
        this.documento = data.documento
        console.log(this.documento)
        this.urlDoc = this.documento?.url
        console.log(this.urlDoc);
        
        this.centro = this.documento.centro
        console.log(this.centro)
        this.tipoAut = this.documento.nombreArchivo
        console.log(this.tipoAut)
        switch (this.tipoAut) {
          case 'residuosPeligrosos':
            this.comentarios1 = Object.assign([], this.centro.comentariosResPeligrosos);
            break;
          case 'residuosNoPeligrosos':
            this.comentarios1 = Object.assign([], this.centro.comentariosResNoPeligrosos);
            break;
          case 'contratoTratamiento1':
            this.comentarios1 = Object.assign([], this.centro.comentariosContrato1);
            break;
          case 'informeResiduos':
            this.comentarios1 = Object.assign([], this.centro.comentariosJustResiduos);
            console.log(this.comentarios1)
            break;
          /* case 'declaracionResiduos':
            this.comentarios5 = Object.assign([], this.centro.comentariosAutorizacion5);
            break; */
        
          default:
            break;
        }
        console.log(this.comentarios1)
      this.getDocumentosByCentro()
      
      })
  }

   addDocumento(){
    
    this.getDate(this.datosReemplazo.value.fechaValidez)
    this.getOtherDate(this.datosReemplazo.value.fechaCaducidad)
    

    this.idPadre = this.documento.id

   if (this.documento.tipo === "activo" || this.documento.tipo === "enEspera") {
      this.tipo= "pendiente"
    }
    if (this.datosReemplazo.value.noCaduca === '') {
      this.datosReemplazo.value.noCaduca = null
    }
  console.log(this.documento.id)
    this.apollo.mutate<any>({
      mutation: this.documentoServicio.addDocumento(),
      variables: {
        "input": {
          "data": {
            "centro":this.centro.id,
            "nombre": this.nameDocumento,
            "fechaValidez": this.date,
            "fechaCaducidad": this.otherDate,
            "obligatorio": true,
            "solicitudReemplazo": false,
            "tipo":this.tipo,
            "idPadre": this.idPadre,
            "noCaduca": this.datosReemplazo.value.noCaduca,
            "nombreArchivo": this.documento.nombreArchivo,
            "url": this.url,
            "comentariosNuevos": true,
            "subidoPor": this.userLog.id
          }
        }
      }
    }).subscribe(({data}) => {
      console.log('OK', data)
     this.updateDocumentoAnteriorById()  
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
}

 updateDocumentoAnteriorById(){
   console.log(this.documento)
   if (this.documento.tipo === "enEspera" || this.documento.tipo === "activo" ) {
      this.tipo = "activo" 
    }  
    this.apollo.mutate({
      mutation: this.documentoServicio.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": this.documento.id
          },
          "data": {
            "tipo": this.tipo,
            "url":this.url,
            "comentariosNuevos": true
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }

   getDocumentosByCentro(): void{ 
    this.apollo.watchQuery<any>({
      query: this.documentoServicio.getDocumentosByCentro(),
      variables: {
        id: this.centro.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {

        this.Documento = [];

        this.documentos= data.centro.documentos;
        
        switch (this.tipoAut) {
          case "residuosPeligrosos":
            this.documentoSeleccionado1 = this.documentos.filter((documento: any) => documento.nombreArchivo === 'residuosPeligrosos')
            this.pendiente= this.documentoSeleccionado1.filter((documento:any)=> documento.tipo === 'pendiente')
            break;

          case "residuosNoPeligrosos":
            this.documentoSeleccionado2 = this.documentos.filter((documento: any) => documento.nombreArchivo === 'residuosNoPeligrosos')
            this.pendiente= this.documentoSeleccionado2.filter((documento:any)=> documento.tipo === 'pendiente')
            break;

          case "informeResiduos":
            this.documentoSeleccionado3 = this.documentos.filter((documento: any) => documento.nombreArchivo === 'informeResiduos')
            this.pendiente= this.documentoSeleccionado3.filter((documento:any)=> documento.tipo === 'pendiente')
            break;  

          case "contratoTratamiento":
            this.documentoSeleccionado4 = this.documentos.filter((documento: any) => documento.nombreArchivo === 'contratoTratamiento')
            this.pendiente= this.documentoSeleccionado4.filter((documento:any)=> documento.tipo === 'pendiente')
            break;
          
          case "declaracionResiduos":
            this.documentoSeleccionado5 = this.documentos.filter((documento: any) => documento.nombreArchivo === 'declaracionResiduos')
            this.pendiente= this.documentoSeleccionado5.filter((documento:any)=> documento.tipo === 'pendiente')
            break;
        
          default:
            break;
        }
      })
  }

}
